import React from 'react';
import { useDispatch } from 'react-redux';
import LazyLoad from 'react-lazyload';
import cx from 'classnames';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { Link } from '@zola/zola-ui/src/components/Link';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import { openModal } from 'cards/actions/modalActions';
import upsellBg from 'assets/images/digitalSaveTheDate/upsellBg.png';
import iphoneBg from 'assets/images/digitalSaveTheDate/iphoneBg.png';
import styles from './styles.module.less';

export const DigitalHowItWorksTile = () => {
  const dispatch = useDispatch();
  return (
    <div className={cx(styles.listingDetail, styles.digital)}>
      <div className={styles.content}>
        <h3 className={styles.digitalTitle}>How it works</h3>
        <ol className={cx(styles.digitalContent, styles.digitalList)}>
          <li>Customize a digital design</li>
          <li>We&apos;ll create a link for easy online access</li>
          <li>
            Text it to everyone at once through{' '}
            <LinkV2
              href="https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916"
              target="_blank"
              inline
            >
              our app
            </LinkV2>
            , or send to guests individually
          </li>
        </ol>
        <ButtonV2
          className={styles.digitalBtn}
          onClick={() => dispatch(openModal('DIGITAL_HOW_IT_WORKS', {}, { size: 'md' }))}
        >
          Learn More
        </ButtonV2>
        <Link
          role="button"
          onClick={() => dispatch(openModal('DIGITAL_HOW_IT_WORKS', {}, { size: 'md' }))}
          className={styles.digitalLink}
          arrow
          arrowPosition="postfix"
        >
          Learn More
        </Link>
      </div>
      <div className={styles.digitalImg}>
        <LazyLoad once offset={100}>
          <img src={iphoneBg} alt="How it works" />
        </LazyLoad>
      </div>
    </div>
  );
};

export const PrintedUpsell = () => (
  <div className={cx(styles.listingDetail, styles.digital)}>
    <div className={styles.content}>
      <h3 className={styles.digitalTitle}>Get Physical with Printed Paper Save the Dates</h3>
      <div className={styles.digitalContent}>
        Many couples go hybrid and do both digital and paper.
      </div>
      <ButtonV2
        className={styles.digitalBtn}
        onClick={() => {
          window.location.pathname = '/wedding-planning/save-the-date/shop';
        }}
      >
        View Paper Save the Dates
      </ButtonV2>
      <Link
        href="/wedding-planning/save-the-date/shop"
        className={styles.digitalLink}
        arrow
        arrowPosition="postfix"
        role="link"
      >
        View Paper
      </Link>
    </div>
    <div className={styles.digitalImg} style={{ paddingRight: 0, paddingTop: 0 }}>
      <LazyLoad once offset={100}>
        <img src={upsellBg} alt="Try printed cards" />
      </LazyLoad>
    </div>
  </div>
);
